<div class="breadcrumbsSection">
    <div class="breadcrumbsContainer">
        @for (menu of menuItems;track menu) {
        <span class="individualBreadcrumb">
            <span [ngClass]="$index!=menuItems.length-1 ? 'navText' : ''" (click)="redirectToRoute(menu, $index)">
                {{menu.label}}</span>
        </span>
        }
    </div>
    <div class="otherDetailsContainer">
        @if(buttonDetails?.length) {
        @for(button of buttonDetails;let i = $index; track button) {
        <button type="button" mat-raised-button class="ml-10" [disabled]="button.isDisabled" [routerLink]="button.route"
            color="primary">{{button.name}}</button>
        }
        }
    </div>
</div>